import { Injectable } from "@angular/core";
import {
  MatDialogConfig,
  MatDialog,
} from "@angular/material/dialog";
import { Router } from "@angular/router";
import { ErrorDialogComponent } from "@core/components/error-dialog/errordialog.component";
import { SharedService } from "@core/services/shared/shared.service";
@Injectable()
export class ErrorDialogService {
  public isDialogOpen: Boolean = false;
  constructor(public _dialogErr: MatDialog, private _sharedInfo: SharedService, private _router: Router) { }
  openModalErr(dataErr): any {
    if (this.isDialogOpen) {
      return false;
    }
    let dialogErrConfig = new MatDialogConfig();
    dialogErrConfig = {
      width: "370px",
      height: "auto",
      data: dataErr,
      disableClose: true,
      autoFocus: false,
      panelClass: "custom-error-dialog",
    };

    if (dataErr.codeError) {
      this.isDialogOpen = true;
      const dialogErr = this._dialogErr.open(ErrorDialogComponent, dialogErrConfig);

      dialogErr.afterClosed().subscribe((responseErrDialog) => {
        this._sharedInfo.setData(responseErrDialog, "dialogErr");
        this.isDialogOpen = false;
      });
    }
  }
}
